import { Box, Button, Slider, Typography } from 'src/components';
import { useTripMap, exportAnimationVideo } from 'src/utils';
import MapStyleSelector from './map-style-selector';
import ColorPicker from './color-picker';
import DistancePicker from './distance-picker';
import { useState } from 'react';
import { useIsMobile } from 'src/hooks';

export default function AnimationControlsFooter({mapRef, routeRef, startAnimation, stopAnimation}) {
    const isMobile = useIsMobile();

    const {
        animationDuration,
        setAnimationDuration,
        mapStyle,
        setMapStyle,
        lineColor,
        setLineColor,
        distanceUnit,
        setDistanceUnit,
        pitch
    } = useTripMap();

    const [tempDuration, setTempDuration] = useState(animationDuration);
    const [isExporting, setIsExporting] = useState(false);
    const [exportProgress, setExportProgress] = useState(0);

    const onExport = async () => {
        if (!mapRef.current || !routeRef.current?.coordinates) {
            console.warn('Map or route data not available');
            return;
        }

        try {
            stopAnimation(); // Stop current animation

            await exportAnimationVideo(
                startAnimation, 
                mapRef.current, 
                routeRef.current.coordinates, 
                setIsExporting,
                {
                    animationDuration,
                    color: lineColor,
                    pitch,
                    onProgress: (progress) => {
                        setExportProgress(Math.round(progress.progress * 100));
                    }
                }
            );

            console.log('Export completed!');
            
        } catch (error) {
            console.error('Export failed:', error);
        } finally {
            setExportProgress(0);
        }
    };

    return (
        <Box 
            sx={{
                position: isMobile ? 'absolute' : 'relative',
                bottom: 0,
                left: isMobile ? 0 : 0,
                right: isMobile ? 0 : 'auto',
                width: '100%',
                height: isMobile ? 140 : '100%',
                px: 3,
                py: isMobile ? 0 : 3,
                background: 'rgba(255,255,255,0.95)',
                borderRight: isMobile ? 'none' : '1px solid #ccc',
                display: 'flex',
                flexDirection: 'column',
                zIndex: 1001,
            }}
        >
            <Box display="flex" gap={2} alignItems="center" sx={{ marginTop: -1 }}>
                <Typography variant="body2" fontWeight={600}>
                    Duration
                </Typography>
                
                <Slider
                    size="small"
                    min={7000}
                    max={20000}
                    step={100}
                    value={tempDuration}
                    onChange={(e, val) => setTempDuration(val)}
                    onChangeCommitted={(e, val) => setAnimationDuration(val)}
                    disabled={isExporting}
                />

                <Typography variant="body2" fontWeight={600} sx={{ width: '90px' }}>
                    {Math.round(tempDuration / 1000)} secs
                </Typography>
            </Box>

            <Box display="flex" flexDirection={isMobile ? 'row' : 'column'} justifyContent="space-between" width="100%">
                <MapStyleSelector mapStyle={mapStyle} setMapStyle={setMapStyle} />
                <ColorPicker selectedColor={lineColor} setSelectedColor={setLineColor} />
                <DistancePicker distanceUnit={distanceUnit} setDistanceUnit={setDistanceUnit} />
            </Box>

            {isExporting && exportProgress > 0 && (
                <Box sx={{ mt: 1, mb: 1 }}>
                    <Typography variant="body2" color="primary">
                        Exporting... {exportProgress}%
                    </Typography>
                    <Box sx={{ width: '100%', mt: 1 }}>
                        <div style={{
                            width: '100%',
                            backgroundColor: '#e0e0e0',
                            borderRadius: '4px',
                            overflow: 'hidden'
                        }}>
                            <div style={{
                                width: `${exportProgress}%`,
                                height: '6px',
                                backgroundColor: '#1976d2',
                                transition: 'width 0.3s ease'
                            }} />
                        </div>
                    </Box>
                </Box>
            )}

            {/* <Button 
                onClick={onExport} 
                variant="contained" 
                fullWidth
                disabled={isExporting}
                sx={{ mt: 1 }}
            >
                {isExporting ? 'Exporting Video...' : 'Export Video'}
            </Button> */}
        </Box>
    );
}